<template>
    <div>
        <Header :class="{fixedHeader:fixedHeader}"></Header>
        <div class="container wide-scroll-on-mobile">
        <dealsDashBoard :dashBoard="dashBoard"></dealsDashBoard>
        <!-- <sip></sip> -->
        <!-- <sipClient></sipClient> -->
        <div class="row mt-4 mb-2 justify-content-between">
            <div class="mr-2">
                <!-- <button type="button" v-tooltip="$ml.get('COLUMN_VIEW')" class="btn btn-click p-2 active">
                    <i class="fa fa-columns font-m"></i>
                </button> -->
                <button type="button" v-tooltip="$ml.get('LIST_VIEW')" class="btn btn-click btn-crm-secondary p-2" @click="$router.push('opportunities')">
                    <i class="fa fa-list font-m"></i>
                </button>
            </div>
            <div class="d-flex">
                <!-- Add deal butonu -->
                <div class="mr-2 addBtn">
                    <button type="button" data-toggle="modal" data-target="#addDeal" @click="modalClear=false" class="btn bg-new-primary f-14 h-100">
                        <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_OPORTUNITY')}}
                    </button>
                </div>
                <div class="selectArea d-flex sortDeal border-0">
                    <div class="first text">
                        {{$ml.get('SORT')}}
                    </div>
                    <div class="last">
                        <div class="btn-group">
                            <button type="button" class="dropdown-button border-top-bottom-right-radius-4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{sortkey}}
                            <i class="fa fa-angle-down pull-right ml-2"></i>
                            </button>
                            <ul class="overflow-x-inherit dropdown-menu dropdown-menu-right p-0 new-dropdown">
                                <li value="title" class="dropdown-item child-dropdown">{{$ml.get('ESTIMATED_CLOSING')}} <i class="fa fa-angle-right pull-right"></i>
                                    <ul class="dropdown-menu p-0 new-dropdown">
                                        <li class="dropdown-item" @click="changeSort($ml.get('RECENT_DATE_ON_TOP'),1,'expectedDate',1)" :class="{tick:sortId==1}">{{$ml.get('RECENT_DATE_ON_TOP')}}</li>
                                        <li class="dropdown-item" @click="changeSort($ml.get('RECENT_DATE_OF_BELOW'),2,'expectedDate',-1)" :class="{tick:sortId==2}">{{$ml.get('RECENT_DATE_OF_BELOW')}}</li>
                                    </ul>
                                </li>
                                <li value="title" class="dropdown-item child-dropdown">{{$ml.get('CREATION_DATE')}} <i class="fa fa-angle-right pull-right"></i>
                                    <ul class="dropdown-menu p-0 new-dropdown">
                                        <li class="dropdown-item" @click="changeSort($ml.get('RECENT_DATE_ON_TOP'),3,'addDate',-1)" :class="{tick:sortId==3}">{{$ml.get('RECENT_DATE_ON_TOP')}}</li>
                                        <li class="dropdown-item" @click="changeSort($ml.get('RECENT_DATE_OF_BELOW'),4,'addDate',1)" :class="{tick:sortId==4}">{{$ml.get('RECENT_DATE_OF_BELOW')}}</li>
                                    </ul>
                                </li>
                                <li value="title" class="dropdown-item child-dropdown">{{$ml.get('EXPECTED_AMOUNT')}} <i class="fa fa-angle-right pull-right"></i>
                                    <ul class="dropdown-menu p-0 new-dropdown">
                                        <li class="dropdown-item" @click="changeSort($ml.get('DECREASING'),5,'value',-1)" :class="{tick:sortId==5}">{{$ml.get('DECREASING')}}</li>
                                        <li class="dropdown-item" @click="changeSort($ml.get('ASCENDING'),6,'value',1)" :class="{tick:sortId==6}">{{$ml.get('ASCENDING')}}</li>
                                    </ul>
                                </li>
                                <li value="title" class="dropdown-item child-dropdown">{{$ml.get('DEGREE')}} <i class="fa fa-angle-right pull-right"></i>
                                    <ul class="dropdown-menu p-0 new-dropdown">
                                        <li class="dropdown-item" @click="changeSort($ml.get('URGENT'),7,'rate',-1)" :class="{tick:sortId==7}">{{$ml.get('URGENT')}}</li>
                                        <li class="dropdown-item" @click="changeSort($ml.get('NORMAL'),8,'rate',1)" :class="{tick:sortId==8}">{{$ml.get('NORMAL')}}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <filterComponent @filter="filter=$event,getDeals('emitter')" :customFields="this.customFields" :users="this.users" :isUsersList="true" :pageIs="pageIs" :isEmpty="isFilterEmpty" />

                <div class="table-setting ml-2">
                  <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"> 
                      <i class="fa fa-ellipsis-v font-m "></i>
                  </button>
                    <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                      <ul class="new-dropdown p-0 border-0" style="overflow:hidden">
                          <li>
                             <!-- İmport Deal Button -->
                            <a type="button" class="" @click="importExcelBtn()">
                                {{$ml.get('IMPORT_EXCEL')}}
                                <i class="fas fa-file-import float-left pr-2" style="padding-top:11px;">
                                        <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                </i>
                            </a>
                          </li>
                      </ul>
                    </div>
                </div>
            
            </div>
        </div>
        <div class="alert alert-secondary alert-dismissible fade show"  v-if="totalCount == 0" role="alert">
            <strong>{{$ml.get('WARNING')}}</strong>
            {{$ml.get('NOT_FOUND_MESSAGE')}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            </div>
        <div class="row" :class="{fixedTitle:fixedTitle}" style="background-color:#f3f6f9">
            <div class="col-md-3 border-top-0 border-bottom-0">
                <div class="row bg-new-blue stepTopBorder"></div>
                <div class="row border-line-right-80 py-3">
                    <div class="col-12 d-flex justify-content-between ">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="font-family-bold pull-left stateTitle">{{$ml.get('STEP_1')}}</h3>
                            <!-- <label class="light-darkGray-color font-11 ml-2" v-if="stageInfo[1]!=undefined">{{stageInfo[1]['count']}}</label> -->
                        </div>
                        
                    </div>
                    <div class="col-12 d-flex justify-content-between ">
                        <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                            <div class="bg-deal-gray pull-right py-1 px-1">
                            <span class=" font-12 pl-1 pr-2 py-1" v-if="stageInfo[1]!=undefined" style="border-right: 1px solid rgba(41, 63, 80, 0.1);">{{stageInfo[1]['count']}}</span>
                            <span class=" font-12 totalPrice py-1" v-if="stageInfo[1]!=undefined">{{currencySymbol(defaultCurrency)}} {{formatPrice(stageInfo[1]['totalValue'])}}</span>
                            </div>
                            <template #popover>
                                <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                <ul class="list-group list-group-flush price-list ">
                                    <li class="list-group-item" v-for="(currency,index) in currenciesList(1)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                </ul>
                            </template>
                        </v-popover>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-top-0 border-left-0 border-bottom-0">
                <div class="row bg-new-primary stepTopBorder"></div>
                <div class="row py-3 border-line-right-80">
                    <div class="col-12 d-flex justify-content-between ">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="font-family-bold pull-left stateTitle">{{$ml.get('STEP_2')}}</h3>
                            
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between ">
                        <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                            <div class="bg-deal-gray pull-right py-1 px-1">
                            <span class="font-12 pl-1 pr-2 py-1" v-if="stageInfo[2]!=undefined" style="border-right: 1px solid rgba(41, 63, 80, 0.1);">{{stageInfo[2]['count']}}</span>
                            <span class="font-12 totalPrice py-1" v-if="stageInfo[2]!=undefined">{{currencySymbol(defaultCurrency)}} {{formatPrice(stageInfo[2]['totalValue'])}}</span>
                            </div>
                            <template #popover>
                                <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                <ul class="list-group list-group-flush price-list ">
                                    <li class="list-group-item" v-for="(currency,index) in currenciesList(2)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                </ul>
                            </template>
                        </v-popover>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-top-0 border-left-0 border-bottom-0">
                <div class="row bg-new-secondry stepTopBorder"></div>
                <div class="row py-3 border-line-right-80">
                    <div class="col-12 d-flex justify-content-between ">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="font-family-bold pull-left stateTitle">{{$ml.get('STEP_3')}}</h3>
                            
                        </div>
                        
                    </div>
                    <div class="col-12 d-flex justify-content-between ">
                        <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                            <div class="bg-deal-gray pull-right py-1 px-1">
                            <span class="font-12 pl-1 pr-2 py-1" v-if="stageInfo[3]!=undefined" style="border-right: 1px solid rgba(41, 63, 80, 0.1);">{{stageInfo[3]['count']}}</span>
                            <span class="font-12 totalPrice py-1" v-if="stageInfo[3]!=undefined">{{currencySymbol(defaultCurrency)}} {{formatPrice(stageInfo[3]['totalValue'])}}</span>
                            </div>
                            <template #popover>
                                <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                <ul class="list-group list-group-flush price-list ">
                                    <li class="list-group-item" v-for="(currency,index) in currenciesList(3)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                </ul>
                            </template>
                        </v-popover>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-top-0 border-left-0 border-bottom-0">
                <div class="row bg-new-darkSecondry stepTopBorder"></div>
                <div class="row py-3">
                    <div class="col-12 d-flex justify-content-between ">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="font-family-bold pull-left stateTitle">{{$ml.get('STEP_4')}}</h3>
                            
                        </div>
                        
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                        <v-popover  popoverClass="currencypop" :trigger="popoverTrigger" :delay="popoverDelay">
                            <div class="bg-deal-gray pull-right py-1 px-1">
                            <span class="font-12 pl-1 pr-2 py-1" v-if="stageInfo[4]!=undefined" style="border-right: 1px solid rgba(41, 63, 80, 0.1);">{{stageInfo[4]['count']}}</span>
                            <span class="font-12 totalPrice py-1" v-if="stageInfo[4]!=undefined">{{currencySymbol(defaultCurrency)}} {{formatPrice(stageInfo[4]['totalValue'])}}</span>
                            </div>
                            <template #popover>
                                <label class="font-weight-bold p-list-title">{{$ml.get('PRICE_LIST')}}</label>
                                <ul class="list-group list-group-flush price-list ">
                                    <li class="list-group-item" v-for="(currency,index) in currenciesList(4)" v-bind:key="index"><div class="d-flex"><div class="curr-shortcode">{{currencyLabel(currency.currency)}} : {{currency.count}}</div><div>{{$ml.get('DEALS_TOTAL')}}</div><div class="ml-auto">{{currencySymbol(currency.currency)}} {{formatPrice(currency.price)}}</div></div></li>
                                </ul>
                            </template>
                        </v-popover>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="stepsTitle" style="background-color:#f3f6f9;">
            <div class="col-md-3 border-line-right-80 border-top-0 border-bottom-0 h-100">
                <div class="row">
                    <div class="col-12">
                            <draggable ref="draggable" :options="{group:'people',animation: 0}" style="min-height: 1700px;" id="1" @start="dragStart" @end="dragEnd">
                                <template v-for="i in stage1" :key="i._id.$oid">
                                    <div class="dealList p-2 mb-2" :id="i._id.$oid" :cuid="i.cuid.$oid" v-if='i.stageId===1 || i.stageId===undefined' @dblclick="detail(i._id.$oid)">
                                    <div class="d-flex wrap-flex">
                                        <div class="w-100 d-block pull-left">
                                            <span :class="statu(i)" class="dateInfo pull-left dealTag">{{statu(i,"getMessage",$ml,$ml.current)}}
                                                <i class="fas fa-calendar-check float-left pt-1 pr-1"></i>
                                            
                                            </span>
                                           
                                            <span v-if="i.rate!==null" class="pull-right">
                                                <img src="~/../assets/rate-dusuk.png" v-if="i.rate==1" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-normal.png" v-if="i.rate==2" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-acil.png" v-if="i.rate==3" v-tooltip.left="getRates(i.rate)"/>
                                            </span>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <p class="hover-color-primary cursor-pointer m-0 companyName" v-if="i.orgId && i.orgId._id" @click="organizationCard(i.orgId._id.$oid)" v-tooltip="i.orgId.name || ''"> {{shortName(i.orgId.name)}}</p>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <div class="f-12 bg-new-gray dealTitle pull-left dealTag" v-tooltip="i.title">{{shortName(i.title)}}</div>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <label class="f-12 pb-0 mb-0 pull-left bg-price dealTag">{{currencySymbol(i.currency)}} {{formatPrice(i.value)}}</label>
                                            <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('ACTIVITIES')" v-if="i.activityList!=undefined && i.activityList.length!=0">
                                                <i class="fa fa-list-ol" aria-hidden="true"></i>
                                                {{i.activityList.filter(e=>e.x==true).length}}
                                            </span>
                                            <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('NOTES')" v-if="i.notes!=undefined && i.notes.length!=0">
                                                <i class="fas fa-sticky-note" aria-hidden="true"></i>
                                                {{i.notes.length}}
                                            </span>
                                            <span v-if="dealUser(i)" class="pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer" v-tooltip.left="dealUserLabel(i)">
                                                {{dealUserInitials(i)}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                </template>
                            </draggable>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-line-right-80 border-top-0 border-left-0 border-bottom-0 h-100">
                <div class="row">
                    <div class="col-12">
                            <draggable ref="draggable" :options="{group:'people',animation: 0}" id="2" style="min-height: 1700px;" @start="dragStart" @end="dragEnd">
                                <template v-for="i in stage2" :key="i._id.$oid">
                                    <div class="dealList p-2 mb-2" :id="i._id.$oid" :cuid="i.cuid.$oid" v-if='i.stageId===2 || i.stageId===undefined' @dblclick="detail(i._id.$oid)">
                                    <div class="d-flex wrap-flex">
                                        <div class="w-100 d-block pull-left">
                                            <span :class="statu(i)" class="dateInfo pull-left dealTag">{{statu(i,"getMessage",$ml,$ml.current)}}
                                            <i class="fas fa-calendar-check pt-1 pr-1 float-left"></i>
                                            </span>
                                            <span v-if="i.rate!==null" class="pull-right">
                                                 <img src="~/../assets/rate-dusuk.png" v-if="i.rate==1" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-normal.png" v-if="i.rate==2" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-acil.png" v-if="i.rate==3" v-tooltip.left="getRates(i.rate)"/>
                                            </span>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <p class="cursor-pointer hover-color-primary m-0 companyName" v-if="i.orgId && i.orgId._id" @click="organizationCard(i.orgId._id.$oid)" v-tooltip="i.orgId.name || ''"> {{shortName(i.orgId.name)}}</p>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <div class="f-12 bg-new-gray dealTitle pull-left dealTag" v-tooltip="i.title">{{shortName(i.title)}}</div>
                                        </div>
                                        <div class="w-100 d-block pull-left">
                                            <label class="f-12 pb-0 mb-0 pull-left bg-price dealTag">{{currencySymbol(i.currency)}} {{formatPrice(i.value)}}</label>
                                            <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('ACTIVITIES')" v-if="i.activityList!=undefined && i.activityList.length!=0">
                                                <i class="fa fa-list-ol" aria-hidden="true"></i>
                                                {{i.activityList.filter(e=>e.x==true).length}}
                                            </span>
                                            <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('NOTES')" v-if="i.notes!=undefined && i.notes.length!=0">
                                                <i class="fas fa-sticky-note" aria-hidden="true"></i>
                                                {{i.notes.length}}
                                            </span>
                                            <span v-if="dealUser(i)" class="pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer" v-tooltip.left="dealUserLabel(i)">
                                                {{dealUserInitials(i)}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                </template>
                            </draggable>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-line-right-80 border-top-0 border-left-0 border-bottom-0 h-100">
                <div class="row">
                    <div class="col-12">
                        <draggable ref="draggable" :options="{group:'people',animation: 0}" id="3" style="min-height: 1700px;" @start="dragStart" @end="dragEnd">
                            <template v-for="i in stage3" :key="i._id.$oid">
                                <div class="dealList p-2 mb-2" :id="i._id.$oid" :cuid="i.cuid.$oid" v-if='i.stageId===3 || i.stageId===undefined' @dblclick="detail(i._id.$oid)">
                                <div class="d-flex wrap-flex">
                                    <div class="w-100 d-block pull-left">
                                        <span :class="statu(i)" class="dateInfo pull-left dealTag">{{statu(i,"getMessage",$ml,$ml.current)}}
                                            <i class="fas fa-calendar-check float-left pt-1 pr-1"></i>
                                        </span>
                                        <span v-if="i.rate!==null" class="pull-right">
                                             <img src="~/../assets/rate-dusuk.png" v-if="i.rate==1" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-normal.png" v-if="i.rate==2" v-tooltip.left="getRates(i.rate)"/>
                                                <img src="~/../assets/rate-acil.png" v-if="i.rate==3" v-tooltip.left="getRates(i.rate)"/>
                                        </span>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <p class="cursor-pointer hover-color-primary m-0 companyName" v-if="i.orgId && i.orgId._id" @click="organizationCard(i.orgId._id.$oid)" v-tooltip="i.orgId.name || ''"> {{shortName(i.orgId.name)}}</p>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <div class="f-12 bg-new-gray dealTitle pull-left dealTag" v-tooltip="i.title">{{shortName(i.title)}}</div>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <label class="f-12 pb-0 mb-0 pull-left bg-price dealTag">{{currencySymbol(i.currency)}} {{formatPrice(i.value)}}</label>
                                        <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('ACTIVITIES')" v-if="i.activityList!=undefined && i.activityList.length!=0">
                                            <i class="fa fa-list-ol" aria-hidden="true"></i>
                                            {{i.activityList.filter(e=>e.x==true).length}}
                                        </span>
                                        <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('NOTES')" v-if="i.notes!=undefined && i.notes.length!=0">
                                            <i class="fas fa-sticky-note" aria-hidden="true"></i>
                                            {{i.notes.length}}
                                        </span>
                                        <span v-if="dealUser(i)" class="pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer" v-tooltip.left="dealUserLabel(i)">
                                            {{dealUserInitials(i)}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            </template>
                        </draggable>
                    </div>
                </div>
            </div>
            <div class="col-md-3 border-top-0 border-left-0 border-bottom-0 h-100">
                <div class="row">
                    <div class="col-12">
                        <draggable ref="draggable" :options="{group:'people',animation: 0}" id="4" style="min-height: 1700px;" @start="dragStart" @end="dragEnd">
                            <template v-for="i in stage4" :key="i._id.$oid">
                                <div class="dealList p-2 mb-2" :id="i._id.$oid" :cuid="i.cuid.$oid" v-if='i.stageId===4 || i.stageId===undefined' @dblclick="detail(i._id.$oid)">
                                <div class="d-flex wrap-flex">
                                    <div class="w-100 d-block pull-left">
                                        <span :class="statu(i)" class="dateInfo pull-left dealTag">{{statu(i,"getMessage",$ml,$ml.current)}}
                                        <i class="fas fa-calendar-check float-left pt-1 pr-1"></i>
                                        </span>
                                        <span v-if="i.rate!==null" class="pull-right">
                                             <img src="~/../assets/rate-dusuk.png" v-if="i.rate==1" v-tooltip.left="getRates(i.rate)"/>
                                            <img src="~/../assets/rate-normal.png" v-if="i.rate==2" v-tooltip.left="getRates(i.rate)"/>
                                            <img src="~/../assets/rate-acil.png" v-if="i.rate==3" v-tooltip.left="getRates(i.rate)"/>
                                        </span>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <p class="cursor-pointer hover-color-primary m-0 companyName" v-if="i.orgId && i.orgId._id" @click="organizationCard(i.orgId._id.$oid)" v-tooltip="i.orgId.name || ''"> {{shortName(i.orgId.name)}}</p>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <div class="f-12 bg-new-gray dealTitle pull-left dealTag" v-tooltip="i.title">{{shortName(i.title)}}</div>
                                    </div>
                                    <div class="w-100 d-block pull-left">
                                        <label class="f-12 pb-0 mb-0 pull-left bg-price dealTag">{{currencySymbol(i.currency)}} {{formatPrice(i.value)}}</label>
                                        <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('ACTIVITIES')" v-if="i.activityList!=undefined && i.activityList.length!=0">
                                            <i class="fa fa-list-ol" aria-hidden="true"></i>
                                            {{i.activityList.filter(e=>e.x==true).length}}
                                        </span>
                                        <span class="pull-left dealTag f-12 ml-1" v-tooltip="$ml.get('NOTES')" v-if="i.notes!=undefined && i.notes.length!=0">
                                            <i class="fas fa-sticky-note" aria-hidden="true"></i>
                                            {{i.notes.length}}
                                        </span>
                                        <span v-if="dealUser(i)" class="pull-right bg-new-gray dealTag f-12 ml-1 cursor-pointer" v-tooltip.left="dealUserLabel(i)">
                                            {{dealUserInitials(i)}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            </template>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-fixed w-100" :class="{ active:active }" style="bottom:10px;opacity:0;visibility: hidden;">
            <div class="row">
                <div class="offset-md-3 col-12 col-sm-6 border-radius-20 p-2 border-line-80">
                    <div class="col-2 float-left text-center">
                        <draggable v-if="((ownerId==dealOwner&&$can('can_delete_deals'))||(ownerId!=dealOwner&&$can('can_delete_other_users_deals')))" :options="{group:'people'}" class="statuClass" id="delete" style="min-height: 50px;" @end="dragEnd">
                            <i class="icon-line-sil" style="font-size:50px;"></i>
                        </draggable>
                    </div>
                    <div class="col-5 float-left">
                        <draggable :options="{group:'people'}" class="statuClass" id="won" style="min-height: 50px;" @start="drag=false" @end="dragEnd">
                            <button type="button" class="btn btn-success btn-sm border-radius-20 mr-2 w-100" style="height:65px; z-index:99999;">{{$ml.get('WON')}}</button>
                        </draggable>
                    </div>
                    <div class="col-5 float-left">
                        <draggable :options="{group:'people'}" class="statuClass" id="lose" style="min-height: 50px;" @end="dragEnd">
                            <button type="button" class="btn btn-danger btn-sm border-radius-20 w-100" style="height:65px;">{{$ml.get('NOT_WON')}}</button>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>
        <!-- Adding deal modal-->
        <div class="modal fade" ref="dealModal" id="addDeal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:950px">
                <div class="modal-content crm-modal-content">
                        <newdeal :methods='type' @getData="getDeals('emitter')" :modalClear="modalClear" :user="this.user" :users="this.users" :customFieldArray="customFields"></newdeal>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" ref="modalDelete" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content border-radius-20 border-line-80">
                <div class="modal-header">
                    <h5 class="modal-title f-14 font-family-bold f-w-normal">{{$ml.get('ARE_YOU_DELETING_OPPORTUNITY')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-footer dealBtnStyle">
                    <button type="button" class="btn btn-new" data-dismiss="modal" @click="cancelResult">{{$ml.get('NO')}}</button>
                    <button type="button" class="btn btn-new save" @click="okeyButtonActive=true,removeDeal()">{{$ml.get('YES')}}</button>
                </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" ref="modalWon" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content border-radius-20 border-line-80">
                <div class="modal-header">
                    <h5 class="modal-title f-14 font-family-bold f-w-normal">{{$ml.get('WIN_THIS_DEAL')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-footer dealBtnStyle">
                    <button type="button" class="btn btn-new" data-dismiss="modal" @click="cancelResult">{{$ml.get('NO')}}</button>
                    <button type="button" class="btn btn-new save" @click="okeyButtonActive=true,result(2)">{{$ml.get('YES')}}</button>
                </div>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="modalLose" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title f-w-normal font-family-bold" id="exampleModalLongTitle">{{$ml.get('REASONS_FOR_LOSS')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="dealLosePopup border-radius-20 light-blue-border dealBtnStyle">
                            <select v-model="dealLoseSelect" class="form-control w-auto h-32 input-padding f-w-normal font-family-bold ml-2 mr-2 f-14 border-radius-20 light-blue-border">
                                <option value="0">{{$ml.get('COMPETITOR_PREFERRED')}}</option>
                                <option value="1">{{$ml.get('PRICE_ORIENTED_LOSS')}}</option>
                                <option value="2">{{$ml.get('NO_PRODUCT_NEEDED')}}</option>
                                <option value="3">{{$ml.get('OTHER')}}</option>
                            </select>
                            <textarea v-model="dealLoseInput" type="text" class="m-2 pl-2 light-blue-bg-40 light-blue-border-40 w-75 border-radius-20 f-w-normal f-14 font-family-bold pt-2" rows="3" :placeholder="$ml.get('WRITE_DESCRIPTION')"></textarea>
                            <div class="pr-3">
                                <button class="float-right btn btn-lg" style="height:unset" @click="okeyButtonActive=true,result(3)">{{$ml.get('SAVE')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Import File Modal -->
        <!-- <div class="modal fade" id="importExcel" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog mw-100 w-75" role="document">
                <div class="modal-content">
                    <takeImport></takeImport>
                </div>
            </div>
        </div> -->
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import draggable from 'vuedraggable'
  import {mapState} from 'vuex'
  import {mapActions} from 'vuex'
  import {mapGetters} from 'vuex'
  import Newdeal from './newDeal.vue'
  import filterComponent from './filterComponent.vue'
  import takeImport from "./import.vue";
  import axios from 'axios'
  import _ from 'underscore'
  import Header from '@/components/header'
  import dealsDashBoard from '@/components/dealsDashBoard'
  import sip from '@/components/sip'
  import sipClient from '@/components/sipClient'
  export default {
      name: 'deals',
      components: {
          Header,
          draggable,
          Newdeal,
          "filterComponent":filterComponent,
          dealsDashBoard,
          sip,
          sipClient,
          takeImport:takeImport,
      },
      data () {
          return {
              deleteUpdateDeals: false,
              type:'save',
              pagingSize:10,
              pagingOffset:0,
              deals:[],
              stage1:[],
              stage2:[],
              stage3:[],
              stage4:[],
              user:[],
              users:[],
              customFields:[],
              dealId:"",
              stageId:"",
              oldStageId:"",
              filter:"",
              pageIs:"deal",
              resultId:"",
              dealOwner:"",
              active:false,
              dealLoseSelect:0,
              dealLoseInput:"",
              okeyButtonActive:false,
              bottom:false,
              totalCount:0,
              modalClear:false,
              permissions:[],
              userNone:true,
              fixedTitle:false,
              fixedHeader:false,
              sortId:1,
              sortkey:this.$ml.get('RECENT_DATE_ON_TOP'),
              sort:'expectedDate',
              sortType:1,
              stageInfo:[],
              dashBoard:[],
              popoverDelay:{ show: 500, hide: 300 },
              popoverTrigger:"hover",
              dashInfo:[],
              defaultCurrency:localStorage.defaultCurrency,
              isFilterEmpty:false
          }
      },
      computed: {
          ...mapState([
              'baseUrl',
              'windowWidth',
              'maxTabletSize'
          ]),
          ...mapGetters(['ownerId'])
      },
      methods:{
        dealUser(deal) {
            const cuid = deal && deal.cuid && deal.cuid.$oid
            if (!cuid) return null
            return this.users.find(user => {
                const userId = user && user._id && (user._id.$oid || user._id)
                return userId === cuid
            }) || null
        },
        dealUserLabel(deal) {
            const user = this.dealUser(deal)
            return user ? `${user.name || ''} ${user.surName || ''}`.trim() : ''
        },
        dealUserInitials(deal) {
            const user = this.dealUser(deal)
            return user ? `${(user.name || '')[0] || ''}${(user.surName || '')[0] || ''}` : ''
        },
        formatPrice: function(val){
            if(val!==undefined && val!==null && !isNaN(val)){
                return Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
        toFix: function(val){
            if(val!==undefined && val!==null && !isNaN(val)){
                return Number(val).toFixed(2);
            }
            return ''
        },
        toPriceModel:function(price){
            if(price!==undefined && price!==null){
                return price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\,")
            }
            return ''
        },
        shortName: function(value){
            if(value!=null){
                if(value.length>40){
                    return value.substring(0,40)+"..."
                }else{
                    return value
                }
            }
            return ''
        },
        statu: function (value,message,ml,langg) {
            if(value.expectedDate===undefined || value.expectedDate===null){
                if(message){
                    return ml.get('NO_ESTIMATED_CLOSING_DATE')
                }
                return "bg-date-not"
            }else{
                var dealDate=new Date(value.expectedDate.$date)
                var date = new Date()
                var deal_day = dealDate.getDate();
                var deal_month = dealDate.getMonth();
                var deal_year = dealDate.getFullYear();
                var today = date.getDate();
                var this_month = date.getMonth();
                var this_year = date.getFullYear();
                var dealTime = new Date(deal_year,deal_month,deal_day);
                var currentTime = new Date(this_year,this_month,today);
                if(message){
                    if(dealTime<currentTime){
                        return (moment(dealTime).format('DD-MM-YYYY'));
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(langg!='tr'){
                            return "Closes in "+ howDay +" days "
                        }else{
                            return (moment(dealTime).format('DD-MM-YYYY'));
                        }
                    }else{
                        return ml.get('CLOSED_TODAY');
                    }
                }else{
                    if(dealTime<currentTime){
                        return "bg-date-summary"
                    }else if(dealTime>currentTime){
                        var howDay = Math.round((dealTime - currentTime) / (1000 * 60 * 60 * 24))
                        if(howDay<=3){
                            return "bg-date-near-next"
                        }
                        return "bg-date-next"
                    }else{
                        return "bg-date-today-close"
                    }
                }
            }
        },
        importExcelBtn(){
            // console.log('?? importExcelBtn girildi ??')
            this.$refs.importDealValue.opportunityImportBtn()
        },
        currenciesList(stage){
            var list = this.dashInfo.find(info=>info._id==stage)
            if(list){
                return list.prices
            }else{
                return []
            }
        },
          getDealsDashboard(){
            axios({
              method:'POST',
              url:'/getDealsDashboard',
              baseURL: this.baseUrl,
              withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status.code==="0"){
                        this.dashBoard=res.data.content.dealsDashboard
                  
                  }
                  else{
                      this.$notify({
                          group: 'foo',
                          type: 'error',
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc
                      })
                  }
              })
          },
          changeSort(sortKey,sortId,sort,sortType){
             this.sortkey=sortKey
             this.sortId=sortId
             this.sort=sort
             this.sortType=sortType
             this.getDeals('emitter')
          },
          result(statu){
              let obj={}
              if(statu===3){
                  let array=[this.$ml.get('COMPETITOR_PREFERRED'),this.$ml.get('PRICE_ORIENTED_LOSS'),this.$ml.get('NO_PRODUCT_NEEDED'),this.$ml.get('OTHER')]
                  obj={
                      status:statu,
                      stageId:5,
                      lostReason:array[this.dealLoseSelect]+` : ${this.dealLoseInput}`
                  }
              }else{
                  obj={
                      status:statu,
                      stageId:5,
                  }
              }
              axios({
              method:'POST',
              url:'/updateDeal',
              baseURL: this.baseUrl,
              data: {
                  dealId:this.resultId,
                  dealUpdateObj:obj
              },
              withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(!res.data.status){
                      this.$router.push('/logout')
                  }
                  $(this.$refs.modalWon).modal("hide")
                  $(this.$refs.modalLose).modal("hide")
                  if(res.data.status.code==="0"){
                      this.$notify({
                          group: 'foo',
                          type: 'success',
                          title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc
                      })
                      this.okeyButtonActive=false
                  }else{
                      this.$notify({
                          group: 'foo',
                          type: 'error',
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc
                      })
                  }
              })
          },
          cancelResult(){
              if(this.okeyButtonActive===false){
                  this.$router.go(0);
              }
          },
          permissionSet(){
              if(!this.permissions.includes("can_delete_deals")){
                  this.$notify({
                      group: 'foo',
                      type: 'error',
                      title: this.$ml.get('ERROR'),
                      text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                  })
                  return true
              }else{
                  return false
              }
          },
          removeDeal(){
              axios({
                  method:'POST',
                  url:'/deleteDeal',
                  baseURL: this.baseUrl,
                  data:{
                      dealId:this.resultId,
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status===false){
                      this.$router.push('/logout')
                  }
                  $(this.$refs.modalDelete).modal("hide")
                  if(res.data.status.code==="0"){
                      this.$notify({
                          group: 'foo',
                          type: 'success',
                          title: this.$ml.get('SUCCESSFUL'),
                          text: res.data.status.desc
                      })
                  }else{
                      this.$notify({
                          group: 'foo',
                          type: 'error',
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc
                      })
                  }
              })
          },
          dragStart(event){
              this.active=true
              this.oldStageId=event.to.id
              this.dealOwner=event.item.attributes.cuid.value
          },
          dragEnd(event){
              this.active=false
              this.dealId=event.item.id
              this.stageId=event.to.id
              if(this.stageId==="won"){
                  $(this.$refs.modalWon).modal()
                  this.resultId=this.dealId
              }else if(this.stageId==="lose"){
                  $(this.$refs.modalLose).modal()
                  this.resultId=this.dealId
              }else if(this.stageId==="delete"){
                  $(this.$refs.modalDelete).modal()
                  this.resultId=this.dealId
              }else{
                  if(this.oldStageId!==this.stageId){
                      axios({
                      method:'POST',
                      url:'/updateDeal',
                      baseURL: this.baseUrl,
                      data: {
                          dealId:this.dealId,
                          dealUpdateObj:{
                              status:1,
                              stageId:parseInt(this.stageId)
                          }
                      },
                      withCredentials:true
                      }).then((res)=>{
                          return res
                      }).then((res)=>{
                          if(!res.data.status){
                              this.$router.push('/logout')
                          }
                          if(res.data.status.code==="0"){
                              this.$notify({
                                  group: 'foo',
                                  type: 'success',
                                  title: this.$ml.get('SUCCESSFUL'),
                                  text: res.data.status.desc
                              })
                              this.getDeals("emitter")
                          }else{
                              this.$notify({
                                  group: 'foo',
                                  type: 'error',
                                  title: this.$ml.get('ERROR'),
                                  text: res.data.status.desc
                              })
                          }
                      })
                  }
              }
          },
          getDeals(emitter){
              this.isFilterEmpty=false
              if(emitter!==undefined){
                  this.pagingOffset=0
                  if(screen.height>720){
                      this.pagingSize=15
                  }else{
                      this.pagingSize=10
                  }
              }
              axios({
                  method:'POST',
                  url:'/getDeals',
                  baseURL: this.baseUrl,
                  data: {
                      pagingSize:this.pagingSize,
                      pagingOffset:this.pagingOffset,
                      filter:this.filter,
                      sort:this.sort,
                      sortType:this.sortType
                  },
                  withCredentials:true
              }).then((res)=>{
                      return res
              }).then((res)=>{
                  if(!res.data.status){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.stageInfo=[]
                      this.dashInfo = res.data.content.dashInfo
                    //   console.log("DASHINFO");
                    //   console.log(this.dashInfo);
                      for(var stage in res.data.content.dashInfo){
                        this.stageInfo[res.data.content.dashInfo[stage]['_id']]=res.data.content.dashInfo[stage]
                      }
                      if(emitter!==undefined){
                          this.stage1=[]
                          this.stage2=[]
                          this.stage3=[]
                          this.stage4=[]
                      }
                      this.totalCount = res.data.content.pageInfo['totalCount']
                      for(var deal in res.data.content.stage1){
                          let dealObj = res.data.content.stage1[deal]
                          this.stage1.push(dealObj)
                      }
                      for(var deal in res.data.content.stage2){
                          let dealObj = res.data.content.stage2[deal]
                          this.stage2.push(dealObj)
                      }
                      for(var deal in res.data.content.stage3){
                          let dealObj = res.data.content.stage3[deal]
                          this.stage3.push(dealObj)
                      }
                      for(var deal in res.data.content.stage4){
                          let dealObj = res.data.content.stage4[deal]
                          this.stage4.push(dealObj)
                      }
                      this.customFields=res.data.content.customFields
                      this.user=res.data.user
                      this.users=res.data.users
                      this.permissions=res.data.permissions

                      if(this.stage1.length==0 && this.stage2.length==0 && this.stage3.length==0 && this.stage4.length==0){
                        this.isFilterEmpty=true
                      }
                      
                  }
                  else if(res.data.status.code==2054) {
        this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
      }
                  else{
                      this.$notify({
                          group: 'foo',
                          type: 'error',
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc
                      })
                  }
              })
          },
          detail(id){
              if(id!==""){
                  localStorage.dealId=id
                  this.updateDealId(id)
                  window.open('/dealCard/'+id, '_blank');
              }
          },
          organizationCard(id){
              if(id!==""){
                  localStorage.orgId=id
                  this.updateOrgId(id)
                  window.open('/organizationCard/'+id, '_blank');
              }
          },
          contactCard(id){
              if(id!==""){
                  localStorage.contactId=id
                  this.updateContactId(id)
                  window.open('/contactCard/'+id, '_blank');
              }
          },
          ...mapActions([
              'updateDealId',
              'updateOrgId',
              'updateContactId',
              'updateLoading'
          ]),
          bottomVisible() {
              const scrollY = document.documentElement.scrollTop
              const visible = document.documentElement.clientHeight
              const pageHeight = document.documentElement.scrollHeight
              const bottomOfPage = visible + scrollY >= pageHeight
              return bottomOfPage || pageHeight < visible
          },
          clearModal(){
              this.modalClear=true
          },
          toDate(dateStr) {
              const [day, month, year] = dateStr.split("-")
              return new Date(year, month - 1, day)
          },
          getRates(rate){
            var rates={ 1:this.$ml.get('NORMAL'),2:this.$ml.get('PRIORITY'),3:this.$ml.get('URGENT') }
            return rates[rate]
          },
      },
      mounted(){
          $(this.$refs.modalLose).on("hidden.bs.modal", this.cancelResult)
          $(this.$refs.modalWon).on("hidden.bs.modal", this.cancelResult)
          $(this.$refs.modalDelete).on("hidden.bs.modal", this.cancelResult)
          $(this.$refs.dealModal).on("hidden.bs.modal", this.clearModal)
          if(screen.height>720){
              this.pagingSize=15
          }else{
              this.pagingSize=10
          }
      },
      created(){
          if(this.windowWidth<this.maxTabletSize){
            this.$router.push('/opportunities')
          }
          window.addEventListener('scroll', () => {
              if(document.getElementById("stepsTitle") !== null){
                if(document.documentElement.scrollTop > document.getElementById("stepsTitle").offsetTop){
                    this.fixedTitle=true
                    this.fixedHeader=true
                }else{
                    this.fixedTitle=false
                    this.fixedHeader=false
                }
                this.bottom = this.bottomVisible()
            }
          })
          if(screen.height>720){
              this.pagingSize=15
          }else{
              this.pagingSize=10
          }
          this.getDealsDashboard()
          this.getDeals()
      },
      watch:{
          windowWidth(){
            if(this.windowWidth<this.maxTabletSize){
                this.$router.push('/opportunities')
            }
          },
          bottom(bottom) {
              if (bottom) {
                  this.pagingOffset+=this.pagingSize
                  this.getDeals()
              }
          },
      },
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .price-list > .list-group-item{
    padding:5px;
}
.fixedHeader{
    display: none;
}
.price-list .curr-shortcode{
    width: 25%;
}
.p-list-title{
    padding-left:5px;
}
.v-popover{
    cursor:context-menu;
}
    .max-width-fill{
        width: -webkit-fill-available!important;
    }
  .statuClass div{
      display: none!important;
  }
  .active{
      visibility: visible!important;
      opacity: 1!important;
      transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .dealLosePopup input{
      border: 1px;
      height: 45px;
  }
  .list-style-none li{
    list-style: none;
  }
  .dealStatus div.statu:first-child {
    margin-left: 0px;
    z-index: 9;
  }
  .dealStatus div.statu:last-child {
    z-index: 2;
  }
  .dealStatus div.statu {
    margin-left: -40px;
  }
  .filterItem{
      padding: .25rem 1.5rem;
  }
  .dealStatus div.statu button {
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 32px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 13px;
    width: auto;
  }
  .dealStatus label {
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 10px;
    color: gray;
    padding-left: 25px;
  }
  .dealStatus .active {
    border-color: #59d816!important;
    color: #59d816!important;
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 13px;
  }
  .fixedTitle{
    position: fixed;
    width: 1140px;
    top: 0;
    z-index: 99;
    background-color: #eceff5;
  }
  .stepTopBorder{
      height: 15px;
  }
  .stepTopBorder:before{
    content: "";
    position: absolute;
    /* right: -8px; */
    z-index: 9;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
  }
  .stepTopBorder.bg-new-blue:before{
    border-left: 8px solid #53a3f2;
  }
  .stepTopBorder.bg-new-primary:before{
    border-left: 8px solid #3c89d8;
  }
  .stepTopBorder.bg-new-secondry:before{
    border-left: 8px solid #306aa8;
  }
.sortable-chosen{
    position: relative;
    border: 2px dashed #e1e1e1;
    opacity: 0.4;
}
@media (min-width: 992px) {
    .wide-scroll-on-mobile{
        padding-right:15px!important;
    }
    .max-width-fill{
        width: -webkit-fill-available!important;
    }
    .fixedTitle{
        width: 1140px;
    }
}
  </style>
